import { createAction, props } from '@ngrx/store';
import { DateOfStay } from 'src/objects/date-of-stay';

import { Destination } from '../../../objects/destination';
import { Product } from '../../../objects/product';
import { Storefront } from '../storefront.service';

export const setProduct = createAction(
  '[Product] Set Product',
  props<{product: Product | null}>(),
);

export const setProductQuantity = createAction(
  '[Product] Set Product Quantity',
  props<{product: Product | null; quantity: number}>(),
);

export const loadProducts = createAction(
  '[Product] Load Products',
  props<{destination: Destination; storefront: Storefront | null}>(),
);

export const loadProductsSuccess = createAction(
  '[Product] Load Products Success',
  props<{products: Product[]}>(),
);

export const loadProductsFailure = createAction(
  '[Product] Load Products Failure',
  props<{error: Error}>(),
);

export const loadProductsByIds = createAction(
  '[Product] Load Products By IDs',
  props<{ids: number[]}>(),
);

export const loadProductsByIdsSuccess = createAction(
  '[Product] Load Products By IDs Success',
  props<{products: Product[]}>(),
);

export const loadProductsByIdsFailure = createAction(
  '[Product] Load Products By IDs Failure',
  props<{error: Error}>(),
);

export const loadProduct = createAction(
  '[Product] Load Product',
  props<{slugOrId: number | string}>(),
);

export const loadProductSuccess = createAction(
  '[Product] Load Product Success',
  props<{product: Product}>(),
);

export const loadProductFailure = createAction(
  '[Product] Load Product Failure',
  props<{error: Error}>(),
);

export const loadProductInventoryCount = createAction(
  '[Product] Load Product Inventory Count',
  props<{ product: Product; destination: Destination; dateOfStay: DateOfStay | null }>(),
);
export const loadProductInventoryCountSuccess = createAction(
  '[Product] Load Product Inventory Count Success',
  props < { product: Product; destination: Destination; count: number | null }>(),
);
export const loadProductInventoryCountFailure = createAction(
  '[Product] Load Product Inventory Count Failure',
  props<{ product: Product; destination: Destination; error: Error }>(),
);
